import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Responsive CSS grid wrapper for cards. `minItemWidth` drives
 * auto-fill so the grid reflows naturally across breakpoints.
 */
@Component({
  selector: 'vh-result-grid',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--vh-grid-min]': 'minItemWidthPx()',
    '[style.--vh-grid-gap]': 'gapPx()',
  },
  template: `<ng-content />`,
  styleUrl: './result-grid.component.scss',
})
export class VhResultGridComponent {
  readonly minItemWidth = input<number>(240);
  readonly gap = input<number>(20);

  protected readonly minItemWidthPx = computed(() => `${this.minItemWidth()}px`);
  protected readonly gapPx = computed(() => `${this.gap()}px`);
}
